import { useIonToast } from '@ionic/react';
import { useCallback } from 'react';

import { alertCircleOutline } from 'ionicons/icons';

/**
 * Custom hook to display toast notifications using Ionic's toast component.
 * Provides a standardized toast function with default styling and behavior.
 * @returns A function to display toast notifications with customizable options.
 */
const useToast = () => {
  const [toast] = useIonToast();
  const displayToast = useCallback(
    ({
      message,
      duration = 2500,
      position = 'bottom',
      positionAnchor = undefined
    }: {
      message: string;
      duration?: number;
      position?: 'bottom' | 'top' | 'middle';
      positionAnchor?: string;
    }) => {
      toast({
        message,
        duration,
        position,
        positionAnchor,
        icon: alertCircleOutline,
        color: 'dark',
        mode: 'ios'
      });
    },
    [toast]
  );

  return displayToast;
};

export default useToast;
